import { createStore } from "zustand-x"
import type { AdminAccount } from "@/domain/admin/model/Admin"

/**
 * 관리자 세션 상태.
 *
 * 토큰 자체는 `AdminTokenUtils` 가 보관하고 여기에는 두지 않는다 —
 * 저장 위치가 두 곳이 되면 로그아웃에서 한쪽만 지워지는 사고가 난다.
 */
interface AdminAuthStoreState {
  account: AdminAccount | null
  /** 세션 확인이 끝났는지 — 가드가 깜빡이지 않게 첫 확인 전에는 대기한다 */
  isChecked: boolean
  isLoading: boolean
  errorMessage: string
}

function makeInitAdminAuthState(): AdminAuthStoreState {
  return {
    account: null,
    isChecked: false,
    isLoading: false,
    errorMessage: "",
  }
}

const AdminAuthStore = createStore<AdminAuthStoreState>(
  makeInitAdminAuthState(),
  { name: "AdminAuthStore" },
)

export { AdminAuthStore, makeInitAdminAuthState }
export type { AdminAuthStoreState }
